import * as server from '../entries/pages/dashboard/_page.server.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/dashboard/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/dashboard/+page.server.ts";
export const imports = ["_app/immutable/nodes/3.DH5Fg0ar.js","_app/immutable/chunks/cL9VaPgy.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/chunks/D1kbsK6n.js","_app/immutable/chunks/B4FYT0oR.js","_app/immutable/chunks/BAJkae7J.js","_app/immutable/chunks/Wy6oXzdU.js","_app/immutable/chunks/D-5ps19L.js","_app/immutable/chunks/BGk0RnQK.js","_app/immutable/chunks/Cz-4yBSw.js"];
export const stylesheets = [];
export const fonts = [];
